import { BaseComponent } from 'components/BaseComponent';
import React from 'react';

export default class YoutubeEmbed extends BaseComponent {
  getHash(url: string) {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);

    if (match && match[2].length == 11) {
      return match[2];
    } else {
      return 'error';
    }
  }
  render() {
    if (!this.props.url) {
      return null;
    }

    return (
      <div className="chk-youtube" style={{ width: 'auto' }}>
        <iframe
          width="100%"
          height="100%"
          style={{ border: 'none' }}
          title="youtubeframe"
          src={`https://www.youtube.com/embed/${this.getHash(this.props.url)}?autoplay=1&controls=0&showinfo=0&rel=0`}
        />
      </div>
    );
  }
}
